import axios from "axios";
import { API_URL } from "../constant/Constant";

const AppService = {
  getStates: async () => {
    return await axios.get(`${API_URL}app/states`);
  },

  getCities: async (stateId) => {
    return await axios.get(`${API_URL}app/cities/${stateId}`);
  },

  getHospitals: async (cityId) => {
    return await axios.get(`${API_URL}app/hospital/${cityId}`);
  },

  getAllHospitals: async () => {
    return await axios.get(`${API_URL}app/hospitals`);
  },

  getDoctors: async (hospitalId) => {
    return await axios.get(`${API_URL}app/doctor/${hospitalId}`);
  },

  getAllDoctors: async () => {
    return await axios.get(`${API_URL}app/doctors`);
  },

  getPrograms: async () => {
    return await axios.get(`${API_URL}app/programs`);
  },

  getBanners: async () => {
    return await axios.get(`${API_URL}app/banners`);
  },

  contactUs: async (form) => {
    return await axios.post(`${API_URL}app/contactUs`, form);
  },

  getDocumentByType: async (documentType, config = {}) => {
    return await axios.get(`${API_URL}app/document/${documentType}`, config);
  },
};

export default AppService;
